"use client";

import React from "react";
import { Footer } from "@/components";
import useHomePageData from "@/hooks/useHomePageData";
import {
  HeroSection,
  NetZeroSection,
  GreenTransformSection,
  DigitalTransformSection,
  KienTaoSection,
  NewsSection,
  VideoSection,
} from "./components";
const HomePage: React.FC = () => {
  const { data, handlers } = useHomePageData();

  return (
    <main className="flex-1 relative min-h-screen overflow-hidden" role="main" aria-label="Trang chủ KTX">
      {/* Hero Section */}
      <HeroSection imageSrc={data.heroImage} />

      {/* Main Content Container */}
      <div className="container mx-auto px-2 md:px-4 py-8 md:py-12 lg:py-16">
        {/* NetZero Section */}
        <NetZeroSection cards={data.netZeroCards} />

        {/* Green Transform Section */}
        <GreenTransformSection cards={data.greenTransformCards} />

        {/* Digital Transform Section */}
        <DigitalTransformSection cards={data.digitalTransformCards} />

        {/* Kien Tao Section */}
        <KienTaoSection cards={data.kienTaoCards} />

        {/* News Section */}
        <NewsSection onNewsClick={handlers.handleNewsClick} />

        {/* Video Section */}
        <VideoSection video={data.featuredVideo} />
      </div>

      {/* Footer */}
      <Footer className="mt-12 md:mt-20" />
    </main>
  );
};

export default HomePage;
